/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2304 1.96676L9.04974 0.145508L0.869044 1.96676C0.417145 2.06867 0.0953212 2.46889 0.0927734 2.93212V8.10726C0.0927734 11.0929 2.08321 18.0594 9.04974 20.0499C16.0163 18.0594 18.0067 11.0929 18.0067 8.10726V2.93212C18.0041 2.46889 17.6824 2.06867 17.2304 1.96676Z"
}), 'PrivacyPolitic', {
  viewBox: '-2 -2 22 24'
});